/* eslint-disable @typescript-eslint/naming-convention */
import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateOrUpdateLicencePackageDto } from '../dtos/CreateLicencePackageDto.interface';
import { LicenceDataDto } from '../dtos/getPackageDto.type';
import { LicenceStatusDto } from '../dtos/licenceStatusDto';
/**
 * The createAction function returns a function, that when called returns an object in the shape
 * of the Action interface. The props method is used to define any additional metadata needed
 * for the handling of the action.
 */

export const licenceActions = createActionGroup({
    source: '[Aumico-Users] licences',
    events: {
        get: props<{ payload: string }>(),
        'get success': props<{ payload: LicenceDataDto }>(),
        'get failure': props<{ payload: HttpErrorResponse }>(),
        'Create Licence': props<{
            payload: {
                organizationId: string;
                dto: CreateOrUpdateLicencePackageDto;
            };
        }>(),
        'Create Licence Success': props<{ payload: LicenceDataDto }>(),
        'Create Licence Failure': props<{ payload: HttpErrorResponse }>(),

        'Update Licence': props<{ payload: CreateOrUpdateLicencePackageDto }>(),
        'Update Licence Success': props<{ payload: LicenceDataDto }>(),
        'Update Licence Failure': props<{ payload: HttpErrorResponse }>(),

        'Request Update Licence': emptyProps(),
        'Request Licence Success': emptyProps(),
        'Request Licence Failure': props<{ payload: HttpErrorResponse }>(),

        'Delete Licence': props<{ packageId: string; organizationId: string }>(),
        'Delete Licence Success': props<{ packageId: string; organizationId: string }>(),
        'Delete Licence Failure': props<{ payload: HttpErrorResponse }>(),

        'Get Licence Status': emptyProps(),
        'Get Licence Status Success': props<{ payload: LicenceStatusDto }>(),
        'Get Licence Status Failure': props<{ payload: HttpErrorResponse }>(),
    },
});
